<template>
  <div class="admin-list-page">
    <main class="mt-0">
      <div v-if="isLoading" class="saving-indicator">
        <span class="spinner"></span>
        데이타 로딩 중...
      </div>

      <div class="p-1">
        <h2 class="page-title">외 부 결 제</h2>

        <!-- ============ 결제요청 생성 카드 (한 줄) ============ -->
        <div class="toolbar-card create-card">
          <div class="create-line">
            <div class="create-field field-name">
              <label>결제상품명</label>
              <input type="text" class="form-control" ref="spName" placeholder="50자이내" maxlength="50" v-model="this.spName">
            </div>
            <div class="create-field">
              <label>결제자</label>
              <input type="text" class="form-control" ref="payer" placeholder="40자이내" maxlength="40" v-model="this.payer">
            </div>
            <div class="create-field field-static">
              <label>거래생성일</label>
              <div class="static-value">{{ this.today }}</div>
            </div>
            <div class="create-field">
              <label>여행일자</label>
              <input type="date" class="form-control" ref="tripDate" v-model="this.tripDate">
            </div>
            <div class="create-field">
              <label>연락처</label>
              <input type="text" class="form-control" ref="callNo" placeholder="-제외, 숫자만" maxlength="11" v-model="this.callNo">
            </div>
            <div class="create-field field-price">
              <label>결제금액</label>
              <input type="number" class="form-control amount-input" ref="spPrice" placeholder="숫자만" min="0" v-model="this.spPrice">
            </div>
            <div class="create-field">
              <label>담당자</label>
              <select class="form-select" v-model="this.managerId" ref="managerId">
                <option :value="p.handlerId" :key="i" v-for="(p,i) in this.chargePList">{{ p.handlerNameKor }}</option>
              </select>
            </div>

            
            <div class="create-field field-pax">
              <label>인원수</label>
              <input type="number" class="form-control" ref="spPaxCnt" placeholder="숫자만" min="1" max="1000" v-model="this.spPaxCnt">
            </div>
            <div class="create-field field-memo">
              <label>비고사항</label>
              <input type="text" class="form-control" ref="spPayMemo" placeholder="100자이내" maxlength="100" v-model="this.spPayMemo">
            </div>
            <button type="button" class="btn-create" @click="dataBaseTransaction('C');">
              <i class="bi bi-pencil-square"></i> 생성
            </button>
          </div>
        </div>

        <!-- ============ 필터 툴바 ============ -->
        <div class="toolbar-card">
          <div class="top-container d-flex align-items-center justify-content-between">
            <div class="flex-item">
              <select class="form-select form-select-sm field-select" ref="sel_procCode" v-model="resYear" @change="changeResYear()">
                <option :value="currentYear">{{ currentYear }}년 이후</option>
                <option :value="prevYear">{{ prevYear }}년 까지</option>
              </select>
            </div>

            <div class="flex-item">
              <select class="form-select form-select-sm field-select" ref="sel_procCode" v-model="rProcCode" @change="changeProcCode()">
                <option :value="noVal" disabled>진행상태선택</option>
                <option value="A">전체보기</option>
                <option :value="rProcCode.procCode" :key=i v-for="(rProcCode,i) in rProc">{{rProcCode.procName}}</option>
              </select>
            </div>

            <div class="flex-item hide-cancel-item">
              <label class="hide-cancel-label">
                <input type="checkbox" class="hide-cancel-checkbox" v-model="hideCancel">
                취소건 숨기기
              </label>
            </div>

            <div class="flex-item search-item">
              <div class="search-box">
                <i class="bi bi-search search-icon"></i>
                <input v-model="dataInput" @input="submitAutoComplete" type="text" class="form-control form-control-sm search-input" placeholder="신청자 또는 외부결제코드" />
              </div>
              <div class="autocomplete disabled">
                <div class="ac-item" :key="i" v-for="(res,i) in result" @click="searchData(res)">{{ res }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- ============ 결제금액 요약바 (확정만 계산대상, 취소는 표시 안 함) ============ -->
        <div class="summary-bar">
          <div class="summary-stat stat-confirmed">
            <div class="stat-label">확정 결제금액</div>
            <div class="stat-value">{{ getCurrencyFormat(paymentSummary.confirmedAmt) }} 원</div>
            <div class="stat-sub">{{ paymentSummary.confirmedCnt }}건</div>
          </div>
          <div class="summary-stat stat-pending">
            <div class="stat-label">대기중 (요청/발신전)</div>
            <div class="stat-value">{{ getCurrencyFormat(paymentSummary.pendingAmt) }} 원</div>
            <div class="stat-sub">{{ paymentSummary.pendingCnt }}건</div>
          </div>
        </div>

        <!-- ============ 리스트 테이블 ============ -->
        <div class="table-wrap">
          <table class="table table-bordered fs-6 data-table">
            <thead class="small">
              <tr class="text-center">
                <th style="width:6%;">상태</th>
                <th style="width:6%;">결제</th>
                <th style="width:6%;">생성일</th>
                <th style="width:6%;">결제요청</th>
                <th style="width:7%;">외부결제코드</th>
                <th style="width:10%;">결제상품명</th>
                <th style="width:8%;">결제자</th>
                <th style="width:8%;">여행일자</th>
                <th style="width:8%;">결제액</th>
                <th style="width:8%;">연락처</th>
                <th style="width:6%;">담당자</th>
                <th style="width:4%;">인원수</th>
                <th style="width:8%;">메모사항</th>
                <th style="width:8%;">취소사유</th>
                <th style="width:9%;">기능</th>
              </tr>
            </thead>
            <tbody class="small">
              <tr v-if="!isLoading && reqList.length === 0">
                <td colspan="15" class="empty-row">조건에 맞는 외부결제 내역이 없습니다</td>
              </tr>
              <tr v-else-if="!isLoading && displayList.length === 0">
                <td colspan="15" class="empty-row">취소건 숨기기 조건에 해당하는 표시 항목이 없습니다</td>
              </tr>
              <tr :key="i" v-for="(rList, i) in this.displayList" class="text-center"
                  :class="'row-stat-' + rList.curStat">
                <td>
                  <select class="form-select form-select-sm status-select" ref="cxlFlag" v-model="rList.reqStatus">
                    <option :value="pn.procCode" :key=i v-for="(pn,i) in rProc">{{pn.procName}}</option>
                  </select>
                </td>
                <td>
                  <template v-if="rList.curStat === 'FL'">
                    <div class="fail-badge">결제실패</div>
                    <div class="fail-meta">{{ getDateFormat(rList.failDate) }}</div>
                    <div class="fail-reason" :title="rList.failReason">{{ rList.failReason }}</div>
                  </template>
                  <template v-else>
                    {{ rList.newPaidDate }}
                  </template>
                </td>
                <td>{{ this.getDateFormat(rList.insDate) }}</td>
                <td>{{ rList.kSendDate_new }}</td>
                <td class="text-success code-cell">{{ rList.spResCode }}</td>
                <td class="text-start">{{ rList.spName }}</td>
                <td>
                  <input type="text" class="form-control form-control-sm" ref="payerName" maxlength="50" v-model="rList.payerName">
                </td>
                <td>
                  <input type="date" class="form-control form-control-sm" ref="tripDate" v-model="rList.tripDate">
                </td>
                <td>
                  <input type="number" class="form-control form-control-sm amount-input" ref="payAmt" v-model="rList.payAmt">
                </td>
                <td>
                  <input type="text" class="form-control form-control-sm" ref="callNo" v-model="rList.callNo">
                </td>
                <td>
                  <select class="form-select form-select-sm" v-model="rList.managerId" ref="managerId">
                    <option :value="m.handlerId" :key="i" v-for="(m,i) in this.chargePList">{{ m.handlerNameKor }}</option>
                  </select>
                </td>
                <td>
                  <input type="number" class="form-control form-control-sm" ref="spPaxCnt" min="1" max="1000" v-model="rList.spPaxCnt">
                </td>
                <td>
                  <input type="text" class="form-control form-control-sm" ref="spRemark" v-model="rList.spRemark">
                </td>
                <td>
                  <select class="form-select form-select-sm" ref="cxlFlag" v-model="rList.cxlFlag">
                    <option :value="cx.procCode" :key=i v-for="(cx,i) in cxlFlagList">{{cx.procName}}</option>
                  </select>
                </td>
                <td class="action-cell">
                  <button type="button" class="btn-action btn-edit" @click="infoUpdate(rList.reqStatus, rList.payerName, rList.tripDate, rList.callNo, rList.payAmt, rList.managerId, rList.spRemark, rList.cxlFlag, rList.spPaxCnt, rList.spResCode);" v-if="rList.curStat != 'CX' && rList.curStat != 'PY'">변경</button>
                  <button type="button" class="btn-action btn-cxl" @click="infoCxl(rList.spResCode, rList.cxlFlag);" v-if="rList.curStat != 'CX'">취소</button>
                  <button type="button" class="btn-action btn-send" @click="sendKakao(rList.reqStatus, rList.payerName, rList.tripDate, rList.callNo, rList.payAmt, rList.managerId, rList.cxlFlag, rList.spPaxCnt, rList.spResCode, rList.spName, rList.insDate);" v-if="rList.curStat == 'RP' || rList.curStat == 'CX' || rList.curStat == 'PY'">발신</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import moment from 'moment';
import {genCode} from '../assets/js/genCode'
import { handlerInfo } from '../assets/js/commonFunctions'

export default {
  data() {
    return {
      isLoading: false,         // 로딩중 여부

      chargePList: [],          //담당자리스트

      //외부결제생성정보
      spCode: "",               //외부결제코드
      spName: "",               //결제상품명
      payer: "",                //결제자명
      tripDate: "",             //여행일
      callNo: "",               //연락처
      spPrice: 0,               //외부결제금액
      managerId: "",            //선택담당자
      spPayMemo: "",            //비고사항
      spPaxCnt:1,               //참여인원

      reqList: [],              //외부결제정보
      hideCancel: true,        //취소건 숨기기 여부
      rProc: [],                //진행상태리스트

      cxlFlagList: [],          //취소사유리스트

      skillInput: null,
      result: null,
      arrSearchData: [],

      handTel: [],                //매니저연락처
      handTelCnt: 0,              //수신처갯수
      resYear: String(new Date().getFullYear()),    //기본조회연도(당해연도)
      currentYear: String(new Date().getFullYear()),
      prevYear: String(new Date().getFullYear() - 1),
    };
  },
  created() {
    this.getReqProcLevel();
    this.getManagerList()

    const today_tmp = moment();
    let today1 = moment([today_tmp.year(), today_tmp.month(), today_tmp.date()]);
    this.today = today1.format("YYYY-MM-DD")

    this.getRequestConsultList();

    this.getHandlerInfo()           //알림톡 발송대상 체크
  },
  computed: {
    user() {
      return this.$store.state.user;
    },

    //결제금액 요약 — CX(취소)/FL(실패)만 별도 제외, 나머지는 reqStatus값과 무관하게 paidDate 유무로 확정/대기 판단
    //(실무에서 reqStatus를 CO로 바꾸지 않고 RP/PY 등에 그대로 두는 경우가 많아, 상태값이 아닌 실제 결제일 존재여부를 기준으로 함)
    paymentSummary() {
      let confirmedAmt = 0, confirmedCnt = 0
      let pendingAmt = 0, pendingCnt = 0

      this.reqList.forEach(item => {
        if(item.curStat === 'CX' || item.curStat === 'FL') return   //취소·실패건은 계산대상 아님

        const amt = (item.payAmt || 0) * 1

        if(item.paidDate) {   //결제일이 있으면 확정(reqStatus 값과 무관)
          confirmedAmt += amt
          confirmedCnt++
        } else {               //결제일이 없으면 대기중(요청/발신전)
          pendingAmt += amt
          pendingCnt++
        }
      })

      return { confirmedAmt, confirmedCnt, pendingAmt, pendingCnt }
    },
    //취소건 숨기기 체크 시, 화면표시용으로만 CX(취소) 건을 걸러냄 (reqList 원본/요약계산에는 영향 없음)
    displayList() {
      if(!this.hideCancel) return this.reqList
      return this.reqList.filter(item => item.curStat !== 'CX')
    }
  },
  mounted() {
    //권한없는 로그인 차단
    if(this.user.handlerGrade >= 20 || this.user.handlerGrade == undefined) {
      var swal = require('sweetalert2');
      swal.fire({
        title: '로그인 필요',
        text: '접근권한 확인불가.',
        icon: 'error'
      });
      this.$router.push({path: '/'});
    }

    document.getElementById("user").style.display = "none";
  },
  methods: {
    getDateFormat(date) {
      return this.$dateFormat(date);
    },
    getCurrencyFormat(value)
    {
      return this.$currencyFormat(value);
    },

    //공통 후처리: curStat(요약/버튼 표시용 상태 스냅샷) 설정 + tripDate 포맷팅
    //getRequestConsultList/changeResYear/changeProcCode 세 경로 모두 반드시 이걸 거쳐야 함
    //
    //★ 수정: tb_reqpay.reqPayStatus(SELECT에 추가된 필드)가 'FL'이면 tb_spayinfo.reqStatus
    //  값과 무관하게 무조건 curStat을 'FL'로 우선 반영한다.
    //  이유: 결제실패는 fail_pg.vue/success_pg.vue 양쪽 경로 모두 tb_reqpay는 항상 갱신하지만,
    //  tb_spayinfo(S.reqStatus)는 아직 일부 경로(구 fail_pg.vue)에서 갱신되지 않을 수 있어
    //  S.reqStatus만 보면 실패건이 실패로 안 잡히는 경우가 생김.
    applyRowMeta(list) {
      list.forEach(item => {
        item.curStat = (item.reqPayStatus === 'FL') ? 'FL' : item.reqStatus
        item.tripDate = this.getDateFormat(item.tripDate)
      })
      return list
    },

    //로딩인디케이터
    showLoading() {
      this.$loading.start()
      setTimeout(() => {
        this.$loading.finish()
      }, 3000)
    },

    async getManagerList()
    {
      //담당자정보
      let chargePList = await this.$api("/api/handlerInfo", {})
      if(chargePList.length > 0)
      {
        this.chargePList = chargePList;
      }
    },

    async getReqProcLevel() {
      let rProc = await this.$api("/api/reqProcLevel", {});
      if(rProc.length > 0) {
        this.rProc = rProc
      }
    },

    //외부결제번호생성
    async genCode(param) {
      let chkFlag = "N";
      let rtnCode = "";

      for (let attempts = 0; attempts < 1000 && chkFlag === "N"; attempts++) {
        let today = new Date();
        let yy = today.getFullYear().toString().slice(-2);
        let mm = today.getMonth() + 1;
        let dd = today.getDate();
        let ymd = `${yy}${mm}${dd}`;
        let dCd = param + ymd;

        rtnCode = await genCode(this.$api, dCd);

        let chk_genCode = await this.$api("/api/checkDub_evCode", { param: [rtnCode] });

        if (chk_genCode.length > 0) {
          chkFlag = "N";
        } else {
          chkFlag = "Y";
        }
      }
      if (chkFlag === "N")
      {
        this.$swal.fire("","결제코드 생성횟수 한계에 도달하였습니다.<br>담당자에게 문의(1660-4602)하여 주세요.","warning")
        return false;
      }
      else
      {
        return rtnCode
      }
    },

    dataBaseTransaction(p1){
      if(p1==="C")
      { //행사 생성처리
        this.$swal.fire({
        icon: 'question',
        text: '외부결제를 생성합니까?',
        showCancelButton: true,
        confirmButtonText: '생성',
        cancelButtonText: '취소'
        }).then(async (result) => {
          if (result.isConfirmed)
          {
            let catCode = "SP-"
            let spCode = await this.genCode(catCode)
            this.spCode = spCode      //외부결제코드

            let reqStatus = "IQ";     //진행상태

            let insSpayInfo = await this.$api("/api/insSpayInfo", {param: [
              this.spCode, reqStatus, this.spName, this.payer, this.tripDate, this.callNo, this.spPrice, this.managerId, this.spPayMemo, this.user.handlerId, this.spPaxCnt
            ]})

            if(insSpayInfo.affectedRows < 0 || insSpayInfo.affectedRows === undefined)
            {
              this.$swal.fire('', '생성 중 오류가 발생했습니다(insSpayInfo)', 'error');
              return false;
            }
            else
            {
              this.$swal.fire('', '결제정보가 생성되었습니다', 'success');
              location.reload(true);
            }
          }
        })
      }
    },

    //결제요청 정보처리
    async insReqPay(rCode, rStat, payAmt)
    {
      let checkFlag = ""
      if(rStat === 'RP')
      {
        checkFlag = "N"
      }
      else if(rStat === 'PY')
      {
        checkFlag = "Y"
      }

      let insReqPayInfo = await this.$api("/api/proc_reqSpPay", {param:[
        rCode, rStat, payAmt, checkFlag, this.user.handlerId
      ]})
      if(insReqPayInfo.affectedRows < 0)
      {
        this.$swal.fire('','처리 중 오류발생(insReqPayInfo)<br>관리자에게 문의하세요', 'error')
        return false;
      }
    },

    //외부결제정보변경
    async infoUpdate(rStat, payer, tripDate, callNo, payAmt, managerId, spRemark, cxlFlag, spPaxCnt, rCode){
      if(rStat === 'CX' && (!cxlFlag || cxlFlag == ''))
      {
        this.$swal.fire("", "취소사유를 선택하세요!", "warning")
        return false
      }

      let sPayInfoUpdate = await this.$api("/api/sPayInfoUpdate", {param:[
        rStat, payer, tripDate, callNo, payAmt, managerId, spRemark, cxlFlag, this.user.handlerId, spPaxCnt, rCode
      ]})

      if(sPayInfoUpdate.affectedRows >= 0)
      {
        if(rStat === 'RP')
        {
          this.insReqPay(rCode, rStat, payAmt)
        }
        else if(rStat === 'PY')
        {
          this.insReqPay(rCode, rStat, payAmt)
        }
        this.$swal.fire("","정보가 변경되었습니다","info")
        location.reload(true)
      }
      else
      {
        this.$swal.fire("","정보가 변경 중 오류가 발생했습니다(sPayInfoUpdate)","error")
        return false
      }
    },

    //외부결제취소
    async infoCxl(rCode, cxlFlag){

      if(!cxlFlag || cxlFlag == '')
      {
        this.$swal.fire("", "취소사유를 선택하세요!", "warning")
        return false
      }

      let sPayInfoCxl = await this.$api("/api/sPayInfoCxl", {param:[
        cxlFlag, this.user.handlerId, rCode
      ]})

      if(sPayInfoCxl.affectedRows >= 0)
      {
        this.$swal.fire("","취소되었습니다","info")
        location.reload(true)
      }
      else
      {
        this.$swal.fire("","취소 중 오류가 발생했습니다(sPayInfoCxl)","error")
        return false
      }
    },

    async getHandlerInfo()
    {
      let handTel = await handlerInfo(this.$api);
      if(handTel.length > 0)
      {
        this.handTel = handTel
      }
    },

    //외부결제상태 카카오알림
    async sendKakao(reqStatus, payerName, tripDate, callNo, payAmt, managerId, cxlFlag, spPaxCnt, spResCode, spName, insDate){

      let cxlReason = ""
      if(reqStatus === 'CX' && (!cxlFlag || cxlFlag == ''))
      {
        this.$swal.fire("", "취소사유를 선택하세요!", "warning")
        return false
      }
      else if(reqStatus === 'CX' && (cxlFlag != ''))
      {
        //취소사유처리
        let cxlReason_tmp = this.cxlFlagList.filter((item) => {
          return item.procCode == cxlFlag
        })
        cxlReason = (cxlReason_tmp[0].procName == null || cxlReason_tmp[0].procName == '') ? "" : cxlReason_tmp[0].procName
      }

      let param = "non" + reqStatus

      //담당자처리
      let managerName_tmp = this.chargePList.filter((item) => {
        return item.handlerId == managerId
      })
      let managerName = (managerName_tmp[0].handlerNameKor == null || managerName_tmp[0].handlerNameKor == '') ? "" : managerName_tmp[0].handlerNameKor

      let insKSendHistory = await this.$api("/api/insKSendHistory", {param: [
        spResCode, param, this.user.handlerId
      ]});

      //알림톡 발송대상 확정
      this.handTel.push({aimCall: callNo})
      this.handTelCnt = this.handTel.length

      if(insKSendHistory.affectedRows > 0)
      {
        let promises = []

        if(param == "nonRP")
        {
          let i = 0
          while(i < this.handTelCnt)
          {
            //비회원용 외부결제요청 카카오 알림톡
            let kakaoAlimData =
            {
              clientName: payerName,
              resName: spName,
              resPaxName: payerName,
              resPaxCnt: spPaxCnt,
              dptDate: tripDate,
              resPhone: callNo,
              resCode: spResCode,
              resPayAmount: this.getCurrencyFormat(payAmt),
              resManager: managerName,
              alimFlag: param,
              pdtCode: spResCode,
              clientCall: this.handTel[i].aimCall,
            };

            let promise = this.$api("api/kakaoAlimSend2", {
              param: [{ kakaoAlimData: kakaoAlimData}]
            })

            promises.push(promise)
            i++
          }

          Promise.all(promises).then(() => {
            this.$swal.fire('', '결제요청 알림톡이 발송되었습니다', 'success').then(() => {
              location.reload(true)
            })
          }).catch((error) => {
            console.log("Error calling api: ", error)
          })
        }

        else if(param == "nonPY")
        {
          let j = 0
          while(j < this.handTelCnt)
          {
            let kakaoAlimData =
            {
              clientName: payerName,
              resCode: spResCode,
              resName: spName,
              resPrice: this.getCurrencyFormat(payAmt),
              alimCall: this.handTel[j].aimCall,
              alimFlag: param,
              pdtCode: spResCode
            };

            let promise = this.$api("api/kakaoAlimSend", {
              param: [{ kakaoAlimData: kakaoAlimData}]
            })

            promises.push(promise)

            j++
          }

          Promise.all(promises).then(() => {
            this.$swal.fire('', '예약확정 알림톡이 발송되었습니다', 'success').then(() => {
              location.reload(true)
            })
          }).catch((error) => {
            console.log("Error calling api: ", error)
          })
        }

        else if(param == "nonCX")
        {
          let i = 0
          while(i < this.handTelCnt)
          {
            let kakaoAlimData =
            {
              clientName: payerName,
              resCode: spResCode,
              resDate: this.getDateFormat(insDate),
              dptDate: tripDate,
              cxlDate: this.today,
              cxlRemark: cxlReason,
              alimCall: callNo,
              clientCall: this.handTel[i].aimCall,
              pdtCode: spResCode,
              alimFlag: param,
            };
            let promise = this.$api("api/kakaoAlimSend2", {
              param: [{ kakaoAlimData: kakaoAlimData}]
            })

            promises.push(promise)
            i++
          }

          Promise.all(promises).then(() => {
            this.$swal.fire('', '예약취소 알림톡이 발송되었습니다', 'success').then(() => {
              location.reload(true)
            })
          }).catch((error) => {
            console.log("Error calling api: ", error)
          })
        }
      }
    },

    async getRequestConsultList() {
      this.isLoading = true;
      this.$loading.start();

      let reqList = []
      let reqList_tmp = await this.$api("/api/sPayInfoList_new", {});

      let currentYear = String(new Date().getFullYear())    //당해연도
      reqList = reqList_tmp.filter(e => {return e.insDate.substr(0,4) === currentYear});

      let rProc = await this.$api("/api/reqProcLevel", {});
      if(rProc.length > 0) {
        this.rProc = rProc
      }

      let cxlFlagList = await this.$api("/api/reqStatusInfo2", {param: ['CXL', 'Y']});
      if(cxlFlagList.length > 0)
      {
        this.cxlFlagList = cxlFlagList
      }

      let i=0;
      let arrSearchData = [];
      if(reqList.length > 0) {
        this.applyRowMeta(reqList)
        this.reqList = reqList;

        while(i<reqList.length)
        {
          arrSearchData.push(reqList[i].spResCode, reqList[i].payerName);
          i++;
        }
      }
      this.arrSearchData = arrSearchData;

      this.isLoading = false;
      this.$loading.finish();
    },
    //자동완성기능
    submitAutoComplete() {
      const autocomplete = document.querySelector(".autocomplete");
      let result_tmp = [];
      if (this.dataInput) {
        autocomplete.classList.remove("disabled");
        autocomplete.style.display = "block"
        result_tmp = this.arrSearchData.filter((e) => {
          return String(e).match(new RegExp("^" + this.dataInput.toUpperCase(), "i"));
        });
        this.result = Array.from(new Set(result_tmp));
      }
      else {
        autocomplete.classList.add("disabled");
        autocomplete.style.display = "none";
        this.getRequestConsultList()
      }
    },
    searchData(res) {
      let reqList_tmp = this.reqList;
      if(res.slice(0,2) === "SP") {
        this.reqList = reqList_tmp.filter(e => {return e.spResCode === res});
      }
      else {
        this.reqList = reqList_tmp.filter(e => {return e.payerName === res});
      }
    },
    refProduct(pdtCode) {
      this.$router.push({path: '/detail', query: {productId: pdtCode}});
    },
    goToReqReserveDetail(seqReq, pCode, cCode) {
      this.$router.push({path: '/reserveInfoDetail', query: {seqReq: seqReq, pCode: pCode, cCode: cCode}});
    },

    async changeResYear() {
      this.isLoading = true;
      this.$loading.start();

      if(this.resYear === 'A')
      {
        this.getRequestConsultList();
      }
      else if(this.resYear === this.currentYear)    //당해연도 이후
      {
        let reqList_tmp1 = await this.$api("/api/sPayInfoList_new", {})
        let filtered = reqList_tmp1.filter(e => {return e.insDate.substr(0,4) >= this.currentYear;});
        this.reqList = this.applyRowMeta(filtered);
      }
      else
      {
        let reqList_tmp = await this.$api("/api/sPayInfoList_new", {})
        let filtered = reqList_tmp.filter(e => {return e.insDate.substr(0,4) <= this.prevYear;});
        this.reqList = this.applyRowMeta(filtered);
      }
      this.isLoading = false;
      this.$loading.finish();
    },

    async changeProcCode() {
      if(this.rProcCode === 'A')
      {
        this.getRequestConsultList();
      }
      else
      {
        let reqList_tmp = await this.$api("/api/sPayInfoList", {})
        let filtered = reqList_tmp.filter(e => {return e.reqStatus === this.rProcCode;});
        this.reqList = this.applyRowMeta(filtered);
      }
    },
  }
}
</script>

<style scoped>
@import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/pretendard.css');

.admin-list-page {
  --ink: #0f1720;
  --muted: #3d4652;
  --paper: #f4f6f8;
  --card: #ffffff;
  --line: #d7dce2;
  --accent: #0a6169;
  --accent-soft: #dcf0ef;
  --warn: #a85f14;
  --warn-soft: #fbe8cf;
  --danger: #a52e27;
  --danger-soft: #f8dad8;
  --success: #1f6e44;
  --success-soft: #d9f0e4;
  --point: #5b46c9;
  --cobalt: #1e4fa3;
  --cobalt-soft: #dde7f7;

  font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, 'Malgun Gothic', sans-serif;
  color: var(--ink);
  background: var(--paper);
  min-height: 100%;
  padding: 0.75rem;
}

.page-title {
  text-align: center;
  font-weight: 800;
  letter-spacing: 0.15em;
  color: var(--ink);
  margin: 0.5rem 0 1rem;
}

/* ---------- 로딩 인디케이터 ---------- */
.saving-indicator {
  position: fixed; top: 30%; left: 50%; transform: translate(-50%, -50%);
  z-index: 9999; background: rgba(255,255,255,0.97); border-radius: 12px;
  padding: 1.75rem 2.25rem; box-shadow: 0 4px 24px rgba(20,30,40,0.12);
  display: flex; align-items: center; font-size: 1.15rem; font-weight: 700; color: var(--accent);
}
.spinner {
  width: 26px; height: 26px; border: 4px solid #dfe6e7; border-top: 4px solid var(--accent);
  border-radius: 50%; margin-right: 1rem; animation: spin 1s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

/* ---------- 카드 공통 ---------- */
.toolbar-card {
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 0.9rem 1rem;
  margin-bottom: 0.9rem;
  box-shadow: 0 1px 3px rgba(20,30,40,0.05);
}

/* ---------- 결제요청 생성 카드 (한 줄) ---------- */
.create-line {
  display: flex;
  align-items: flex-end;
  gap: 0.6rem;
  overflow-x: auto;
  padding-bottom: 2px;
}
.create-field {
  display: flex;
  flex-direction: column;
  flex: 1 1 90px;
  min-width: 90px;
}
.create-field.field-name { flex: 1 1 160px; min-width: 140px; }
.create-field.field-static { flex: 0 0 90px; min-width: 90px; }
.create-field.field-price { flex: 1 1 110px; min-width: 100px; }
.create-field.field-pax { flex: 0 0 70px; min-width: 70px; }
.create-field.field-memo { flex: 2 1 200px; min-width: 160px; }

.create-field label {
  display: block;
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--muted);
  margin-bottom: 0.25rem;
  white-space: nowrap;
}
.create-field .form-control,
.create-field .form-select {
  border: 1px solid var(--line);
  border-radius: 8px;
  width: 100%;
}
.static-value {
  padding: 0.375rem 0.1rem;
  color: var(--muted);
  font-weight: 600;
  white-space: nowrap;
}
.amount-input { color: var(--danger); font-weight: 700; }

.btn-create {
  flex: 0 0 auto;
  background: var(--success-soft);
  color: var(--success);
  border: none;
  border-radius: 8px;
  padding: 0.4rem 0.9rem;
  font-weight: 700;
  font-size: 0.8rem;
  white-space: nowrap;
  height: 38px;
}
.btn-create:hover { background: var(--success); color: #fff; }

/* ---------- 필터 툴바 ---------- */
.top-container { display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap; }
.flex-item { margin: 4px; }
.field-select { border: 1px solid var(--line); border-radius: 8px; font-weight: 600; }
.field-select:focus { border-color: var(--accent); box-shadow: 0 0 0 3px var(--accent-soft); }

.hide-cancel-item { display: flex; align-items: center; }
.hide-cancel-label {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--muted);
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.hide-cancel-checkbox {
  width: 15px;
  height: 15px;
  accent-color: var(--accent);
  cursor: pointer;
}

.search-item { position: relative; }
.search-box { position: relative; display: flex; align-items: center; }
.search-icon { position: absolute; left: 10px; color: var(--muted); font-size: 0.85rem; pointer-events: none; }
.search-input { padding-left: 1.9rem; border: 1px solid var(--line); border-radius: 8px; min-width: 220px; }
.search-input:focus { border-color: var(--accent); box-shadow: 0 0 0 3px var(--accent-soft); }

.autocomplete {
  position: absolute; top: 105%; left: 0; right: 0; z-index: 30;
  background: var(--card); border: 1px solid var(--line); border-radius: 8px;
  box-shadow: 0 6px 18px rgba(20,30,40,0.12); max-height: 220px; overflow-y: auto;
}
.autocomplete.disabled { display: none; }
.ac-item { padding: 0.45rem 0.8rem; font-size: 0.85rem; color: var(--success); cursor: pointer; }
.ac-item:hover { background: var(--accent-soft); }

/* ---------- 결제금액 요약바 (확정 / 대기중 2단) ---------- */
.summary-bar {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
  margin-bottom: 0.9rem;
}
.summary-stat {
  background: var(--card);
  border: 1px solid var(--line);
  border-left: 4px solid var(--line);
  border-radius: 10px;
  padding: 0.65rem 0.9rem;
  box-shadow: 0 1px 3px rgba(20,30,40,0.05);
}
.stat-label { font-size: 0.78rem; font-weight: 700; color: var(--muted); margin-bottom: 0.15rem; }
.stat-value { font-size: 1.15rem; font-weight: 800; color: var(--ink); text-align: right; }
.stat-sub { font-size: 0.72rem; color: var(--muted); text-align: right; margin-top: 0.1rem; }

.stat-confirmed { border-left-color: var(--success); }
.stat-confirmed .stat-value { color: var(--success); }
.stat-pending { border-left-color: var(--warn); }
.stat-pending .stat-value { color: var(--warn); }

@media (max-width: 900px) {
  .summary-bar { grid-template-columns: 1fr; }
}

/* ---------- 테이블 ---------- */
.table-wrap {
  background: var(--card); border: 1px solid var(--line); border-radius: 12px;
  overflow: auto; max-height: 68vh; box-shadow: 0 1px 3px rgba(20,30,40,0.05);
}
.data-table { margin-bottom: 0; border: none; }
.data-table thead th {
  position: sticky; top: 0; z-index: 5; background: #eef1f3; color: var(--ink);
  font-weight: 700; border-color: var(--line) !important; box-shadow: 0 1px 0 var(--line);
}
.data-table tbody td { border-color: var(--line) !important; color: var(--ink); vertical-align: middle; }
.data-table tbody tr:nth-child(even) { background: #fafbfc; }
.data-table tbody tr:hover { background: var(--accent-soft); }

.row-stat-PY { border-left: 3px solid var(--success); }
.row-stat-CX { border-left: 3px solid var(--danger); }

.empty-row { padding: 2rem 0; color: var(--muted); font-size: 0.95rem; font-weight: 600; }
.code-cell { font-weight: 700; }

.status-select { border-radius: 6px; font-weight: 600; }
.form-control-sm, .form-select-sm { border: 1px solid var(--line); border-radius: 6px; }

.action-cell { display: flex; gap: 0.3rem; justify-content: center; }
.btn-action { border: none; border-radius: 6px; padding: 0.3rem 0.55rem; font-size: 0.72rem; font-weight: 700; }
.btn-edit { background: var(--accent-soft); color: var(--accent); }
.btn-edit:hover { background: var(--accent); color: #fff; }
.btn-cxl { background: var(--danger-soft); color: var(--danger); }
.btn-cxl:hover { background: var(--danger); color: #fff; }
.btn-send { background: var(--warn-soft); color: var(--warn); }
.btn-send:hover { background: var(--warn); color: #fff; }

.row-stat-FL { border-left: 3px solid var(--danger); }
.fail-badge { color: var(--danger); font-weight: 700; font-size: 0.78rem; }
.fail-meta, .fail-reason { font-size: 0.68rem; color: var(--muted); }
.fail-reason { max-width: 140px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin: 0 auto; }

@media (max-width: 900px) {
  .top-container { justify-content: center; }
  .table-wrap { max-height: 55vh; }
}
</style>